import type { PropTypes } from './List.types';
import type { ReactElement } from 'react';

import { Box, Flex, Separator } from '@rango-dev/whale';
import { CircleStar } from 'lucide-react';
import React, { Fragment, useRef } from 'react';

import { Item } from './Item';
import { ListSkeleton } from './ListSkeleton';

export function List(props: PropTypes): ReactElement {
  const { loading, avatarSize, showLevel } = props;
  const itemRef = useRef<HTMLDivElement | null>(null);
  return (
    <Box ref={itemRef}>
      {loading ? (
        <ListSkeleton
          avatarSize={avatarSize}
          showLevel={showLevel}
          maxLength={props.maxLengthSkeleton}
          enableTopUserSkeleton={props.enableTopUserSkeleton}
        />
      ) : (
        <Flex direction="column" gap="1">
          {props.list.map((item, idx) => (
            <Fragment key={item.id}>
              <Item
                avatarSize={avatarSize}
                scoreIcon={<CircleStar size={20} />}
                isCompactUsername={true}
                item={item}
                {...props}
              />
              {idx < props.list.length - 1 && (
                <Flex>
                  <Separator size="4" color="gray" />
                </Flex>
              )}
            </Fragment>
          ))}
        </Flex>
      )}
    </Box>
  );
}
